import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col justify-between" }
const _hoisted_2 = { class: "w-full pt-[24px] px-[32px] max-h-[calc(100vh-136px)] h-auto overflow-y-auto" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "w-full flex items-center justify-between pt-3 mt-[46px] border-t border-black/15" }

import { ref } from "vue";
import QuestionnaireButtonNext from "../parts/QuestionnaireButtonNext.vue";
import QuestionnaireButtonPrev from "../parts/QuestionnaireButtonPrev.vue";
import QuestionnaireTextArea from "../parts/QuestionnaireTextArea.vue";

type Props = {
  textAreaTitle: string;
  textAreaPlaceholder: string;
  prevButtonText: string;
  nextButtonText: string;
  height?: string;
  description?: string;
};

type Emits = {
  (event: "onSubmit", description: string): void;
  (event: "onStepBack"): void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'AbnahmeDataMissingTextArea',
  props: {
    textAreaTitle: {},
    textAreaPlaceholder: {},
    prevButtonText: {},
    nextButtonText: {},
    height: {},
    description: {}
  },
  emits: ["onSubmit", "onStepBack"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const description = ref(props.description ? props.description : "");
const descriptionError = ref({
  isError: false,
  message: "",
});

const onSubmit = () => {
  if (description.value && description.value.trim()) {
    descriptionError.value.isError = false;
    descriptionError.value.message = "";
    emits("onSubmit", description.value);
  } else {
    descriptionError.value.message = "Description is required!";
    descriptionError.value.isError = true;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "pb-2 text-xl leading-8 tracking-[0.01rem] font-semibold text-primary-text-color" }, " What data is missing? Please write here ", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(QuestionnaireTextArea, {
            modelValue: description.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((description).value = $event)),
            height: __props.height,
            placeholder: __props.textAreaPlaceholder,
            "is-error": descriptionError.value.isError,
            "error-message": descriptionError.value.message
          }, null, 8, ["modelValue", "height", "placeholder", "is-error", "error-message"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createVNode(QuestionnaireButtonPrev, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onStepBack'))),
          "button-text": __props.prevButtonText
        }, null, 8, ["button-text"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(QuestionnaireButtonNext, {
          "is-loading": false,
          onClick: onSubmit,
          "button-text": __props.nextButtonText
        }, null, 8, ["button-text"])
      ])
    ])
  ]))
}
}

})